import { Component, Input, OnInit } from '@angular/core';
import { OperationsService } from 'src/app/core/services/operations.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ViewManagerService } from 'src/app/core/services/view-manager-service';
import { ModalNotifyService } from 'src/app/core/services/modal-notify.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ParametriOpzionaliDocumento } from 'src/app/common/models/fascicolo/parametri-opzionali-documento';
import { AssociativeOpzioniDocumento } from 'src/app/common/models/associativa-opzioni-documento/associativeOpzioniDocumento';


@Component({

  selector: 'define-template',
  templateUrl: 'define-template.html',
  host: {
    '[attr.id]': '\'content\''
  },
  styleUrls: ['./define-template.css']
})


export class DefineTemplate implements OnInit {

  formGroup: FormGroup;
  paramForm: FormGroup;
  flagAnteprima: boolean = true;
  param: ParametriOpzionaliDocumento[];
  parametro: string;
  valore: string;
  parametri = [];
  flagParametri: boolean = true;

  @Input() request = { parametri: null };
  // @Input() inserimento;
  @Input() newList: ParametriOpzionaliDocumento

  constructor(protected operationsService: OperationsService,
    private router: Router,
    viewManager: ViewManagerService,
    private route: ActivatedRoute,
    private modalNotifyService: ModalNotifyService,
    private fb: FormBuilder) {


  }

  tipoPratica;
  tipoFascicolo;
  idFascicolo;
  idSezione;
  idTipoFascicolo;
  resTemplate;
  template;
  titleGestione = 'Definisci Template';

  ngOnInit() {
    // if(this.inserimento){
    this.request.parametri = [];
    // }
    this.initForm();

    this.route.params.subscribe(params => {
      this.tipoPratica = params['tipoPratica']
      this.tipoFascicolo = params['tipoFascicolo']
      this.idFascicolo = params['idFascicolo']
      this.idSezione = params['idSezione']
      this.idTipoFascicolo = params['idTipoFascicolo']
      this.operationsService.getTemplateFascicolo(this.idTipoFascicolo).subscribe(res => this.resTemplate = res)
    })


  }

  initForm(init = false) {
    this.newList = AssociativeOpzioniDocumento.createOption(new ParametriOpzionaliDocumento());
    this.formGroup = this.fb.group({
      flagAnteprima: [true],
      parametri: [
        this.paramForm = this.fb.group({
          id: [init ? null : this.newList.id],
          parametro: [init ? null : this.newList.parametro],
          valore: [init ? null : this.newList.valore]
        })
      ]
    })
  }

  addParam() {
    this.parametri.push(
      {
        parametro: this.paramForm.getRawValue().parametro,
        valore: this.paramForm.getRawValue().valore
      });
    this.paramForm.reset();
  }

  removeParam(obj) {

    this.parametri = this.parametri.filter(item => item !== obj);
  }

  validationParam(event) {
    if (this.paramForm.controls['parametro'].value && this.paramForm.controls['valore'].value) {
      this.flagParametri = false;
    }
    else {
      this.flagParametri = true;
    }
  }

  generaTemplate(template) {

    let extraParams = {}
    this.parametri.forEach(el => {
      extraParams[el.parametro] = el.valore
    })
    console.log(extraParams, 'a')
    let obj = {
      //"tipoPratica": this.tipoPratica,
      //"tipoFascicolo": this.tipoFascicolo,
      "idTipoFascicolo": this.idTipoFascicolo,
      "idFascicolo": this.idFascicolo,
      //"idSezione": this.idSezione,
      "idTemplate": template,
      "anteprima": this.flagAnteprima,
      "extraParams": extraParams
    }

    this.operationsService.generaDocumentoFascicolo(obj).subscribe();
    // this.operationsService.generaDocumento(obj).subscribe(res => {
    //   if (res)
    //   this.modalNotifyService.customMessage('Operazione eseguita con successo! Il documento si trova nella sezione Documentazione Allegata del fascicolo.')
    // });
  }

  goBack() {
    this.router.navigate([sessionStorage.getItem('backLink')])
  }
}
